import { useMemo } from 'react';
import { useAgentCallAgenda } from '../../../shared';

export const useClientsToCall = () => {
  const {state} = useAgentCallAgenda();
  return useMemo(() => (
    state?.tasks.filter(t => !t.completed && t.currentAssignment?.assignedAgentId) || []
  ), [state?.tasks]);
}
